import styled from 'styled-components';

import { breakpoints } from 'components';

export const StyledDetailSectionContainer = styled.div`
  display: grid;
  gap: 16px;
`;

export const StyledDetailInputsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: ${breakpoints.md}px) {
    grid-template-columns: 1fr;
  }
`;
